import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, Center, Stack } from '@mantine/core';

import { Button, SectionText, SectionTitle, TextInput } from 'components';
import { CardService } from 'services';
import { RouteConstants, ServiceConstants } from '../../constants';
import { IRootState } from 'config/redux';
import { useCallback, useEffect, useState } from 'react';
import { AppUtils, CryptoUtils } from 'utils';

const { ROUTE_CREDIT_CARD_FORM } = RouteConstants;
const { REQUEST_CARD_VERIFY_ID } = ServiceConstants;

const CardRequestVerifyPage = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const verifyServiceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CARD_VERIFY_ID]);

  const [accessCode, setAccessCode] = useState<string>('');
  const [accessCodeError, setAccessCodeError] = useState<string>('');

  useEffect(() => {
    AppUtils.resolveServiceObject(
      verifyServiceObject,
      REQUEST_CARD_VERIFY_ID,
      () => {
        navigate(`${ROUTE_CREDIT_CARD_FORM}?cid=${id}`);
      },
      (err) => {
        const data = CryptoUtils.decrypt(err.data);
        setAccessCodeError(t(`input.verify.invalid.${data?.code === 'IDENTITY_NOT_FOUND' ? 'link' : 'code'}`));
      }
    );
  }, [verifyServiceObject]);

  const verifyCode = useCallback(() => {
    setAccessCodeError('');
    if (!isCodeValid(accessCode)) {
      setAccessCodeError(t('input.verify.invalid'));
      return;
    }
    CardService.verify({ accessCode, identification: id! });
  }, [accessCode, id]);

  const isCodeValid = (code: string) => {
    return code?.trim().length === 6 && /^\d{6}$/.test(code);
  }

  return (
    <Box pt={100} bg='linear-gradient(180deg, #123F0A 0%, #4D9140 100%)' p={20} w='100%' h='100vh'>
      <Center mt={20}>
        <Stack>
          <SectionTitle variant='light' title={t('card.verify.title')} />
          <SectionText text={t('card.verify.description')} />
          <Box>
            <TextInput
              label={t('input.verify.label')}
              value={accessCode}
              onChange={(event) => setAccessCode(event.currentTarget.value)}
              labelLight={true}
              error={accessCodeError}
            />
            <Button mt={24} type={'submit'} disabled={!isCodeValid(accessCode)} onClick={verifyCode}>
              {t('action.verify')}
            </Button>
          </Box>
        </Stack>
      </Center>
    </Box >


  )
}

export default CardRequestVerifyPage;